import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { appRoute } from "./route";
import { LeaderboardView } from "@/features/courses/components/leaderboard/leaderboard-view";

export const leaderboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/leaderboard",
  component: withFeatureGate("gamification.core", LeaderboardView),
});
